/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { InboxItemFromJSON, InboxItemToJSON } from './InboxItem';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetInboxesResponseDataFromJSON(json) {
    return GetInboxesResponseDataFromJSONTyped(json, false);
}
export function GetInboxesResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        inboxItems: !exists(json, 'inbox_items') ? undefined : json['inbox_items'].map(InboxItemFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetInboxesResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        inbox_items: value.inboxItems === undefined ? undefined : value.inboxItems.map(InboxItemToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
